export const GeneralDropDowns = (data) => {
    return {
      type: 'GeneralDropDowns',
      payload: data
    }
}
export const AddPatientToDropDowns = (patient) => ({
    type: 'ADD_PATIENT_TO_DROPDOWNS',
    payload: patient
});
